module.exports = __webpack_public_path__ + "01_glasses_black.992d35c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/01_glasses_black.png
// module id = E4A/
// module chunks = 0